import {ApiProvider} from '../providers/api/api';
import {AlertService} from '../providers/util/alert.service';
import {ErrorHandler, NgModule} from '@angular/core';
import {IonicApp, IonicErrorHandler, IonicModule, NavController} from 'ionic-angular';

import {BrowserModule} from '@angular/platform-browser';
import {HttpModule} from '@angular/http';
import {IonicStorageModule} from "@ionic/storage/es2015";

import {SharedModule} from './shared/shared.module';
import {PipeModule} from "../pipes/pipe.module";

import {MyApp} from './app.component';
import {SettingsProvider} from '../providers/settings';
import {AuthenticationProvider} from '../providers/authentication';
import {LoaderProvider} from "../providers/loader";
import {ConstantProvider } from '../providers/constants';

import { BrMaskerModule } from 'brmasker-ionic-3';
import {EmailService} from "../providers/util/email.service";
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
    declarations: [
        MyApp
    ],
    imports: [
        BrowserModule,
        HttpModule,
        SharedModule,
        BrMaskerModule,
        IonicSelectableModule,
        PipeModule.forRoot(),
        IonicModule.forRoot(MyApp),
        IonicStorageModule.forRoot({
            name: '_prm',
            driverOrder: ['websql', 'indexeddb', 'sqlite']  //'indexeddb', 'sqlite', 'websql'
        })
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp
    ],
    providers: [
        LoaderProvider,
        SettingsProvider,
        ConstantProvider,
        AuthenticationProvider,
        ApiProvider,
        AlertService,
        EmailService,
        {provide: ErrorHandler, useClass: IonicErrorHandler}
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts